import { Link } from "react-router-dom";
import leaf1 from "../Images/leaf1.png";
import leaf2 from "../Images/leaf2.png";
import face from "../Images/Face-care.jpg";
import hair from "../Images/hair-care.jpg";
import Body from "../Images/Body-care.jpg";
import Baby from "../Images/Baby-care.jpg";
import Fragrances from "../Images/Fragrance.jpg";

const ShopByCategory = () => {
  return (
    <div className="overflow-hidden">
      <div className="relative">
        {/* Decorative leaf image */}
        <img
          className="w-[120px] lg:w-[300px] absolute top-0 right-[-20px] lg:right-0"
          alt="Decorative green leaf for natural skincare theme"
          src={leaf2}
          loading="lazy"
        />

        {/* ✅ Semantic landmark for SEO */}
        <section
          aria-labelledby="shop-by-category-heading"
          className={`flex flex-col px-[10px] items-center sm:px-[20px] lg:px-[0px] lg:w-[90%] mx-auto ${
            window.innerWidth >= 1920 ? "2xl:w-[65%]" : "2xl:w-[80%]"
          }`}
        >
          {/* ✅ SEO-friendly heading */}
          <h2
            id="shop-by-category-heading"
            className="text-center text-xl text-accent font-bold mt-[50px] sm:text-2xl"
          >
            Shop by Category – Natural Skincare, Haircare & More
          </h2>
          <div className="w-[100px] mx-auto h-1 bg-accent my-6 mb-10"></div>

          {/* ✅ Category grid */}
          <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 lg:gap-6 justify-center items-center">
            {/* ✅ Face Care */}
            <Link
              to="product-category/face wash"
              className="flex flex-col items-center gap-4"
              title="Explore Clariss Face Care Products"
            >
              <img
                src={face}
                alt="Clariss Face Care – Natural Face Wash and Skincare"
                loading="lazy"
              />
              <p className="font-bold">FACE CARE</p>
            </Link>

            {/* ✅ Hair Care */}
            <Link
              to="product-category/hair care"
              className="flex flex-col items-center gap-4"
              title="Discover Clariss Hair Care Range"
            >
              <img
                src={hair}
                alt="Clariss Hair Care – Organic Shampoo and Hair Treatment"
                loading="lazy"
              />
              <p className="font-bold">HAIR CARE</p>
            </Link>

            {/* ✅ Fragrances */}
            <Link
              to="product-category/fragrances"
              className="flex flex-col items-center gap-4"
              title="Clariss Fragrances – Perfumes and Body Mists"
            >
              <img
                src={Fragrances}
                alt="Clariss Fragrances – Perfumes and Body Mists"
                loading="lazy"
              />
              <p className="font-bold">FRAGRANCES</p>
            </Link>

            {/* ✅ Body Care */}
            <Link
              to="product-category/body care"
              className="flex flex-col items-center gap-4"
              title="Clariss Body Care – Lotions, Scrubs & More"
            >
              <img
                src={Body}
                alt="Clariss Body Care – Natural Lotions and Scrubs"
                loading="lazy"
              />
              <p className="font-bold">BODY CARE</p>
            </Link>

            {/* ✅ Baby Care */}
            <Link
              to="product-category/baby care"
              className="flex flex-col items-center gap-4"
              title="Clariss Baby Care – Gentle Skincare for Babies"
            >
              <img
                src={Baby}
                alt="Clariss Baby Care – Gentle skincare for babies"
                loading="lazy"
              />
              <p className="font-bold">BABY CARE</p>
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ShopByCategory;
